export default __webpack_public_path__ + "static/media/2.5f2e3e91.jpg";